import TextInputOnly from 'components/Common/Form/Input/TextInputOnly'
import IconButton from 'LuxKit/Button/IconButton'
import React, { useCallback } from 'react'
import { useIntl } from 'react-intl'
import LineArrowUpIcon from 'LuxKit/Icons/line/LineArrowUpIcon'
import LineCheckIcon from 'LuxKit/Icons/line/LineCheckIcon'
import styled from 'styled-components'
import Group from 'components/utils/Group'
import { rem } from 'polished'

const Container = styled(Group)`
  position: relative;
  > *:first-child {
    flex: 1;
  }
`

const AbsoluteIconButton = styled(IconButton)`
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  right: ${rem(12)};
`

const StyledTextInput = styled(TextInputOnly)`
  input {
    padding-right: ${rem(48)};
  }
`

interface Props {
  freeText?: string
  isLoading?: boolean
  isCoolingDown?: boolean
  validationError?: string
  onFreeTextChange: (e: React.ChangeEvent<HTMLInputElement>) => void
  onSubmit: () => void
}

export default function RegenerateItemInput({
  freeText = '',
  isLoading,
  validationError,
  onFreeTextChange,
  onSubmit,
  isCoolingDown,
}: Props) {
  const intl = useIntl()
  const handleKeyDown = useCallback((event: React.KeyboardEvent<HTMLInputElement>) => {
    if (event.key === 'Enter') {
      event.preventDefault()
      onSubmit()
    }
  }, [onSubmit])

  const isDisabled = !!isLoading || !!isCoolingDown
  const IconComponent = isCoolingDown ? LineCheckIcon : LineArrowUpIcon

  return (
    <Container direction="horizontal" fullWidth>
      <StyledTextInput
        id="regenerate-individual-item-input"
        placeholder={intl.formatMessage({
          id: 'uNPV7GJ28wk7KqTo4UFb',
          defaultMessage: 'Tell us what you would like instead',
          description: 'Placeholder text for the replacement item search input field',
        })}
        value={freeText}
        onChange={onFreeTextChange}
        onKeyDown={handleKeyDown}
        noValidationSpacing
        manualError={!!validationError}
        invalidErrorMessage={validationError}
        disabled={isDisabled}
      />
      <AbsoluteIconButton
        kind="primary"
        size="small"
        shape="circle"
        children={<IconComponent />}
        onClick={onSubmit}
        aria-busy={isLoading}
        disabled={isDisabled}
      />
    </Container>
  )
}
